import { regexFilename } from './regex';

/**
 * Downloads a file with the specified file name and content.
 *
 * @param {string} fileName - The name of the file to be downloaded.
 * @param {string|Blob} content - The content of the file to be downloaded. It can be a string or a Blob.
 * @param {Object} options - Options for the Blob, such as MIME type. Example: { type: 'application/zip' }.
 *
 * @returns {boolean} - Returns true if the download is initiated.
 */
export const downloadFile = (fileName, content, options = {}) => {
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) {
    return window.navigator.msSaveBlob(new Blob([content], { ...options }), fileName);
  }

  const blob = new Blob([content], { ...options });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  });
  return true;
};

/**
 * Retrieves the filename from the response headers.
 *
 * @param {Object} res - The response object containing headers.
 * @returns {string} - The filename extracted from the headers or a default filename.
 */
export const getFilenameFromResponse = (res) => {
  const defaultFilename = 'invoice';
  const contentDisposition = res.headers && res.headers['content-disposition'];

  if (contentDisposition) {
    const matches = regexFilename.exec(contentDisposition);
    if (matches && matches[1]) {
      return matches[1].replace(/['"]/g, '');
    }
  }

  return defaultFilename;
};

export default {
  downloadFile,
  getFilenameFromResponse,
};



// WEBPACK FOOTER //
// ./src/utils/download.js